module.exports = __webpack_public_path__ + "img/elha-logo-black.026c2c79.svg";